import { Fragment } from "react";
import { NavLink } from "react-router";

import { useTranslation } from "react-i18next";

import { LoadingIndicator, Sidebar } from "@destination/components";

import PageIcon from "@/icons/page_16.svg";
import AccountIcon from "@/icons/account_16.svg";
import GatewayIcon from "@/icons/gateway_16.svg";
import ReportingIcon from "@/icons/reporting_16.svg";
import { useApplicationRoles } from "@/hooks/use-application-roles";

export const NavigationItems = () => {
  const { t } = useTranslation("navMenu");
  const { hasRole, isLoading } = useApplicationRoles();

  const baseItems = (
    <NavLink key="provisioning-reports" to="/factory-process-service/provisioning-reports" end>
      {({ isActive }) => (
        <Sidebar.MenuItem
          label={t("provisioning-reports.label")}
          icon={<ReportingIcon />}
          isActive={isActive}
        />
      )}
    </NavLink>
  );

  if (isLoading) {
    return (
      <Fragment>
        {baseItems}
        <div className="flex justify-center py-2">
          <LoadingIndicator />
        </div>
      </Fragment>
    );
  }

  if (hasRole("ServiceManager")) {
    return (
      <Fragment>
        {baseItems}
        <NavLink key="profiles" to="/factory-process-service/profiles" end>
          {({ isActive }) => (
            <Sidebar.MenuItem
              label={t("profiles.label")}
              icon={<AccountIcon />}
              isActive={isActive}
            />
          )}
        </NavLink>
        <NavLink key="station-onboarding" to="/factory-process-service/station-onboarding" end>
          {({ isActive }) => (
            <Sidebar.MenuItem
              label={t("station-onboarding.label")}
              icon={<PageIcon />}
              isActive={isActive}
            />
          )}
        </NavLink>
        <NavLink key="device-provisioning-service" to="/factory-process-service/device-provisioning-service" end>
          {({ isActive }) => (
            <Sidebar.MenuItem
              label={t("device-provisioning-service.label")}
              icon={<GatewayIcon />}
              isActive={isActive}
            />
          )}
        </NavLink>
      </Fragment>
    );
  }

  return baseItems;
};